module.exports = __webpack_public_path__ + "img/featured-vehicles-v2-hyundai.74e10795.png";